import { observer } from 'mobx-react-lite'
import { CalendarDropdown } from 'shared/ui'
import { useReviewAnalyticsContext } from 'pages/reviews/context'
import styles from './styles.module.scss'

export const ReviewAnalyticsCalendar = observer(() => {
  const { calendarFilterStore } = useReviewAnalyticsContext()

  return (
    <div className={styles.wrap}>
      <CalendarDropdown store={calendarFilterStore} triggerProps={{ size: 'small' }} />
    </div>
  )
})
